import React from 'react';
import classNameBind from 'classnames/bind';

import styles from './ExpandableWrapperWithColumns.module.css';

const bindClasses = classNameBind.bind(styles);

const ExpandableWrapperWithColumns = ({
  leftColumn,
  rightColumn,
}) => (
  <div
    data-ppuc-id="List.Item.extendedContent"
    className={bindClasses('wrapper')}
  >
    <div
      data-ppuc-id="List.Item.extendedContent.left"
      className={bindClasses('left-column')}
    >
      {leftColumn}
    </div>
    <div
      data-ppuc-id="List.Item.extendedContent.right"
      className={bindClasses('right-column')}
    >
      {rightColumn}
    </div>
  </div>
);

export default ExpandableWrapperWithColumns;
